import { History, Target, Users } from "lucide-react";
import { Reveal } from "./Reveal";

const CARDS = [
  {
    id: 1,
    Icon: History,
    color: "#C49A8A",
    bg: "rgba(196, 154, 138, 0.1)",
    border: "rgba(196, 154, 138, 0.25)",
    title: "Nuestra historia",
    text: "Nació de la convicción de que la salud mental debe ser accesible para todos. Con empatía y tecnología, construimos un espacio donde nadie tiene que enfrentar sus batallas solo.",
  },
  {
    id: 2,
    Icon: Target,
    color: "#B8D4C8",
    bg: "rgba(184, 212, 200, 0.1)",
    border: "rgba(184, 212, 200, 0.25)",
    title: "Nuestra misión",
    text: "Elevar la conciencia sobre la salud mental aliando psicología y tecnología con una comunidad que crece. Porque nadie debería enfrentarlo solo.",
  },
  {
    id: 3,
    Icon: Users,
    color: "#D4C4B5",
    bg: "rgba(212, 196, 181, 0.1)",
    border: "rgba(212, 196, 181, 0.25)",
    title: "Atención personalizada",
    text: "Gamaliel te acompaña directamente como tu psicólogo, respaldado por un equipo tecnológico y de soporte enfocado en tu bienestar en toda LATAM.",
  },
];

export function QuienesSomos() {
  return (
    <div id="quienes-somos" style={{ position: "relative", zIndex: 1, paddingTop: 80, paddingBottom: 100 }}>
      <div className="container">
        <div className="about-grid">
          {/* Columna izquierda — foto + cita */}
          <Reveal style={{ transitionDuration: "0.8s" }}>
            <div style={{ position: "relative", width: "100%" }}>
              <img
                src="/gamaliel3.jpg"
                alt="Gamaliel Castro"
                className="about-photo-mobile"
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  borderRadius: 20,
                  objectFit: "cover",
                  objectPosition: "center 20%",
                }}
              />
              <div style={{
                marginTop: "16px",
                padding: "16px 20px",
                background: "rgba(212, 196, 181, 0.08)",
                border: "1px solid rgba(212, 196, 181, 0.15)",
                borderRadius: "12px",
                textAlign: "center",
              }}>
                <p style={{
                  color: "#D4C4B5",
                  fontSize: "15px",
                  fontWeight: "700",
                  margin: "0 0 4px",
                }}>
                  Gamaliel Castro
                </p>
                <p style={{
                  color: "rgba(212,196,181,0.6)",
                  fontSize: "12px",
                  margin: "0",
                  letterSpacing: "0.05em",
                }}>
                  Psicólogo · Ingeniero en TICs · Fundador
                </p>
              </div>
            </div>
          </Reveal>

          {/* Columna derecha — contenido */}
          <div>
            <Reveal>
              <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".15em", textTransform: "uppercase", color: "#C49A8A", marginBottom: 16 }}>
                QUIÉNES SOMOS
              </div>
              <h2 style={{
                fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "clamp(1.6rem, 3vw, 36px)",
                lineHeight: 1.2, color: "#FFFFFF", margin: "0 0 20px",
              }}>
                Psicología y tecnología al servicio de tu bienestar
              </h2>

              <p style={{ fontSize: 15, color: "rgba(255,255,255,0.7)", lineHeight: 1.8, marginBottom: 40 }}>
                PzicoDosis nació para cambiar el modelo tradicional de la psicología. Combinamos la comprensión profunda de la mente humana con el poder de la tecnología para hacer la salud mental accesible para todos.
              </p>

              <blockquote style={{
                borderLeft: "3px solid #C49A8A", paddingLeft: 20, marginBottom: 40, marginTop: 0,
                fontStyle: "italic", fontSize: 18, color: "rgba(255,255,255,0.9)",
              }}>
                "La tecnología más poderosa es la que nos ayuda a conectar con nosotros mismos."
              </blockquote>
            </Reveal>

            {/* Tarjetas */}
            <div className="about-cards-grid">
              {CARDS.map((c) => (
                <div
                  key={c.id}
                  className="about-card"
                  style={{
                    background: c.bg,
                    border: `1px solid ${c.border}`,
                    borderTop: `3px solid ${c.color}`,
                  }}
                >
                  <c.Icon size={24} color={c.color} strokeWidth={2} />
                  <div style={{ fontSize: 15, fontWeight: 700, color: "#fff", margin: "12px 0 8px" }}>
                    {c.title}
                  </div>
                  <div style={{ fontSize: 13, color: "rgba(255,255,255,0.65)", lineHeight: 1.6 }}>
                    {c.text}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
